/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "combo-discount-groups-management",
	data() {
		return {
			comboDiscountGroups: [],
			comboDiscountGroupsHeadings: [
				{
					text: "Name",
					field: "name"
				},
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Is Active",
					field: "isActiveAsString"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				linkProducts: "linkProducts"
			},
			comboDiscountGroupMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markComboDiscountGroupAsActiveInactiveModal",
				heading: "Mark Combo Discount Group As Active/Inactive",
				isActive: null,
				comboDiscountGroupId: null
			},
			linkProductsToComboDiscountGroupModal: {
				showModal: false,
				isSaving: false,
				modalId: "linkProductsToComboDiscountGroupModal",
				heading: "Link Products To Combo Discount Group",
				comboDiscountGroupId: null
			},
			filterStateChanged: false,
			filter:{
				searchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false
		};
	},
	methods: {
		getComboDiscountGroups() {
			this.loading = true;
			let request ={
				searchQuery: this.filter.searchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			orderService.getComboDiscountGroups(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.comboDiscountGroups = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.comboDiscountGroups.length; i++) {
							this.comboDiscountGroups[i].isActiveAsString = this.comboDiscountGroups[i].isActive ? "Yes" : "No";
							this.comboDiscountGroups[i].discountAmountAsString = currencyHelper.numberToCurrency(this.comboDiscountGroups[i].discountAmount);
							this.comboDiscountGroups[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.comboDiscountGroups[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									cssClass: "btn btn-warning btn-sm mr-2"
								},
								// {
								// 	name: "Link Products",
								// 	key: this.actionKeys.linkProducts,
								// 	cssClass: "btn btn-info btn-sm"
								// }
							];
						}
					}
					this.loading = false;
				},
				errorResponse => {
					apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
					this.loading = false;
				}
			);
		},
		onAddComboDiscountGroupClick() {
			this.$router.push("/pricing/combo-discount-groups/add");
		},
		onComboDiscountGroupActionClicked(actionAndData) {
			console.log("actionAndData", actionAndData);
			if(actionAndData.action === this.actionKeys.edit) {
				this.$router.push("/pricing/combo-discount-groups/edit/" + actionAndData.data.comboDiscountGroupId);
			}
			else if(actionAndData.action === this.actionKeys.markAsActiveInactive) {
				this.comboDiscountGroupMarkAsActiveInactiveModal.comboDiscountGroupId = actionAndData.data.comboDiscountGroupId;
				this.comboDiscountGroupMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
				this.comboDiscountGroupMarkAsActiveInactiveModal.showModal = true;
			}
			else if(actionAndData.action === this.actionKeys.linkProducts) {
				this.linkProductsToComboDiscountGroupModal.comboDiscountGroupId = actionAndData.data.comboDiscountGroupId;
				this.linkProductsToComboDiscountGroupModal.showModal = true;
			}
		},
		onMarkAsActiveInactiveSaveClick(isActive) {
			this.comboDiscountGroupMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				comboDiscountGroupId: this.comboDiscountGroupMarkAsActiveInactiveModal.comboDiscountGroupId,
				isActive: isActive
			};
			orderService.markComboDiscountGroupAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.comboDiscountGroupMarkAsActiveInactiveModal.showModal = false;
						this.getComboDiscountGroups();
					}
					this.comboDiscountGroupMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.response.data.responseStatus, errorResponse.response.data.httpStatusCode, errorResponse.response.data.message);
					this.comboDiscountGroupMarkAsActiveInactiveModal.isSaving = false;
				}
			);
		},
		onLinkProductsToComboDiscountGroupModalCloseClick() {
			this.linkProductsToComboDiscountGroupModal.showModal = false;
			this.getComboDiscountGroups();
		},
		onLinkProductsToComboDiscountGroupSaveClick() {
			this.linkProductsToComboDiscountGroupModal.showModal = false;
			this.getComboDiscountGroups();
		},
		onPagingUpdated(pageNumber) {
			this.pagingDetails.pageNumber = pageNumber;
			this.getComboDiscountGroups();
		},
		onFilterSearchClicked() {
			this.filterStateChanged = false;
			this.pagingDetails.pageNumber = 1;
			this.getComboDiscountGroups();
		},
		onActiveInactiveFilterSelected(activeInactiveKey) {
			this.filterStateChanged = true;
			this.filter.activeOrInactiveItems = activeInactiveKey;
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Combo Discount Groups Management");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Pricing"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Combo Discount Groups Management"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted() {
		this.setBreadcrumbs();
		this.getComboDiscountGroups();
	}
};